"use client";

import { AlertTriangle } from "lucide-react";

const FMT: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZoneName: "short",
};

function formatWindow(startsAt: string | null, endsAt: string | null): string | null {
  if (!startsAt && !endsAt) return null;
  const parts: string[] = [];
  if (startsAt) parts.push(new Date(startsAt).toLocaleString([], FMT));
  if (endsAt) parts.push(new Date(endsAt).toLocaleString([], FMT));
  return parts.join(" – ");
}

export function MaintenanceBanner({
  message,
  startsAt,
  endsAt,
}: {
  message: string;
  startsAt: string | null;
  endsAt: string | null;
}) {
  const window = formatWindow(startsAt, endsAt);
  return (
    <div className="fixed top-0 left-0 right-0 z-maintenance-banner flex h-[var(--maintenance-banner-h)] items-center justify-center gap-2 bg-amber-500 px-4 text-sm font-medium text-white">
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        {message}
        {window && <span className="opacity-80"> ({window})</span>}
      </span>
    </div>
  );
}
